import React from 'react'
import PropTypes from 'prop-types'
import Autosuggest from 'react-autosuggest'

import TagsInputField from '../../../Shared/TagsInputField'

function SoftwareSelect({ software, availableSoftware, onSoftwareChange }) {
  function autocompleteRenderInput({ addTag, ...props }) {
    const handleOnChange = (e, { newValue, method }) => {
      if (method === 'enter') {
        e.preventDefault()
      } else {
        props.onChange(e)
      }
    }

    const inputValue = (props.value && props.value.trim().toLowerCase()) || ''
    const inputLength = inputValue.length

    const suggestions = availableSoftware.filter((software) => {
      return software.text.toLowerCase().slice(0, inputLength) === inputValue
    })

    return (
      <Autosuggest
        ref={props.ref}
        suggestions={suggestions}
        shouldRenderSuggestions={(value) => value && value.trim().length > 0}
        getSuggestionValue={(suggestion) => suggestion.text}
        renderSuggestion={(suggestion) => <span>{suggestion.text}</span>}
        inputProps={{ ...props, onChange: handleOnChange }}
        onSuggestionSelected={(e, { suggestion }) => addTag(suggestion.text)}
        onSuggestionsClearRequested={() => {}}
        onSuggestionsFetchRequested={() => {}}
        highlightFirstSuggestion
      />
    )
  }

  return (
    <TagsInputField
      id="software"
      label="Software"
      value={software}
      onChange={onSoftwareChange}
      min={5}
      max={20}
      renderInput={autocompleteRenderInput}
      tagIcon="cog"
      tagIconColor="grey-dark"
    />
  )
}

SoftwareSelect.propTypes = {
  software: PropTypes.array.isRequired,
  availableSoftware: PropTypes.array.isRequired,
  onSoftwareChange: PropTypes.func.isRequired,
}

export default SoftwareSelect
